import BaseService from './_base.service';

export const dealeruserService = {
    page,
    edit,
    search,
    create,
    one,
    remove,
    removeLogic
};

function page(page,size, callback) {
    return BaseService.get("/user/dealer/page/"+page+"/"+size, callback, true)
}
function search(page,size,filter, callback) {
    return BaseService.post("/user/dealer/page/"+page+"/"+size,filter, callback, true)
}
function edit(id, bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.put("/user/dealer/"+id, body, callback, true)
}

function create(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post("/user/dealer/", body, callback, true)
}

function one(id,callback) {
    return BaseService.get("/user/dealer/"+id, callback);
}

function remove(id,callback) {
    return BaseService.delete("/user/dealer/"+id, callback);
}

function removeLogic(id,callback) {
    return BaseService.delete("/user/dealer/"+id+"/logic", callback);
}
